/**
 * Team State 简单粗暴版
 */

import {
  getMembers,
  getGroups,
  createGroup,
  removeGroup,
  updateGroup,
  addMembersToGroup,
  removeMemberFromGroup
} from "@/api/team";

export default {
  namespaced: true,
  state: () => ({
    members: null, // 所有团队成员,
    groups: null
  }),
  mutations: {
    SET_MEMBERS(state, value) {
      state.members = value;
    },
    SET_GROUPS(state, value) {
      state.groups = value;
    }
  },
  actions: {
    _getMembers({ commit }) {
      return getMembers().then(({ res }) => {
        commit("SET_MEMBERS", res.data);
        return res.data;
      });
    },
    getMembers({ state, dispatch }) {
      return state.members || dispatch("_getMembers");
    },
    _getGroups({ commit }) {
      return getGroups().then(({ res }) => {
        commit("SET_GROUPS", res.data);
        return res.data;
      });
    },
    getGroups({ state, dispatch }) {
      return state.groups || dispatch("_getGroups");
    },
    createGroup({ dispatch }, name) {
      return createGroup(name).then(() => {
        return dispatch("_getGroups");
      });
    },
    removeGroup({ dispatch }, groupId) {
      return removeGroup(groupId).then(() => {
        return dispatch("_getGroups");
      });
    },
    updateGroup({ dispatch }, { groupId, name }) {
      return updateGroup(groupId, name).then(() => {
        dispatch("_getGroups");
      });
    },
    addMembersToGroup({ dispatch }, { groupId, userIds }) {
      return addMembersToGroup({ groupId, userIds }).then(() => {
        dispatch("_getGroups");
      });
    },
    removeMemberFromGroup({ dispatch }, value) {
      return removeMemberFromGroup(value).then(() => {
        dispatch("_getGroups");
      });
    }
  }
};
